import { IconCheckboxToggleCheckedSVG, IconCheckboxToggleUncheckedSVG } from '../../assets/svg';
import { Component } from '../../types-common';
import { Checkbox, CheckboxProps } from './Checkbox';

export const CheckboxToggle: Component<CheckboxProps> = props => {
  return (
    <Checkbox {...props} icon={<IconCheckboxToggleUncheckedSVG />} checkedIcon={<IconCheckboxToggleCheckedSVG />} />
  );
};
